// Stack class to define a stack
export class Stack {
  constructor(length) {
    this.stack = Array(length)
    this.topIndex = -1
    this.length = length
  }

  // Pushing element inside stack
  push(val) {
    if (this.topIndex === this.length - 1) return -999
    this.stack[++this.topIndex] = val
    return 1
  }

  // Pop element from stack
  pop() {
    if (this.topIndex === -1) return -999
    return this.stack[this.topIndex--]
  }

  top() {
    return this.stack[this.topIndex]
  }
}
